/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { omit } from 'lodash';
// Components
import BaseControl from 'shared/ui/components/form-components/BaseControl.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';

const __vue_script__ = {
    name: 'ContentPagePicker',

    components: {
        BaseSelect
    },

    extends: BaseControl,

    props: {
        event: {
            type: Object,
            required: true
        },

        relatedModel: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            ready: false,
            selectedPage: null,
            pages: [],
            options: [],
            attrs: omit(Object.assign(this.$options.propsData, this.$attrs), ['value', 'event', 'relatedModel'])
        };
    },

    computed: {
        innerValue: {
            get() {
                return this.options.find(o => o.value === this.value);
            },

            set({ value } = {}) {
                this.$emit('input', value);
            }
        }
    },

    created() {
        this.loadPages();
    },

    methods: {
        async loadPages() {
            try {
                this.pages = await this.$services.handlers.callHandler(this.event._id, 'fstg/get-model-pages-basic-info', {
                    relatedModel: this.relatedModel
                });
                this.options = Object.entries(this.pages).map(([id, label]) => ({ value: id, label }));
                this.ready = true;
            } catch (error) {
                console.error(`[ContentPagePicker] Could not load pages for model ${this.relatedModel}`, error);
            }
        },

        async createNewPage() {
            try {
                const name = prompt(this.$t('fstg.create_page.prompt'));
                if (!name) return;

                const page = this.attrs.options.pageDefaults || {};
                const { id } = await this.$services.handlers.callHandler(this.event._id, 'fstg/create-empty-page', {
                    name, page,
                    relatedModel: this.relatedModel
                }, 'post');

                await this.loadPages();
                this.innerValue = this.options.find(o => o.value === id);

            } catch (error) {
                console.error(`[ContentPagePicker] Could not create new page for model ${this.relatedModel}`, error);
            }
        },

        editPage() {
            const url = this.$utils.url.interpolateUrl(this.attrs.options.editRoute, {
                eventId: this.event._id,
                pageId: this.innerValue.value
            });

            this.$router.push(url);
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('base-select',_vm._b({attrs:{"track-by":"value","options":_vm.options},scopedSlots:_vm._u([{key:"control-actions",fn:function(ref){return [_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-mini",attrs:{"type":"button","disabled":!_vm.innerValue},on:{"click":_vm.editPage}},[_vm._v(_vm._s(_vm.$t('general.edit')))]),_c('button',{staticClass:"btn btn-mini",attrs:{"type":"button"},on:{"click":_vm.createNewPage}},[_vm._v(_vm._s(_vm.$t('general.create')))])])]}}],null,false,4188016538),model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'base-select',_vm.attrs,false)):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ContentPagePicker.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__